Librarian.Search = new Class({
    Extends: Librarian.Request.JSON,
    Binds: [
        "onBeforeSearch", "onBeforeXMLGeneration", "search",
        "hasSearchNodes", "hasSearchNode",
        "loadComplete", "addSearchWithin",
        "addFileTerm", "addTextTerm", "addGroupTerm",
        "addFileTermEx", "addTextTermEx", "addGroupTermEx",
        "addTerm", "addFileType", "addAttribute", "addCategorizedAttribute",
        "addFileKeyword", "addSlideKeyword", "addGroupKeyword",
        "addFileKeywordEx", "addSlideKeywordEx", "addGroupKeywordEx",
        "addFileAttribute", "addSlideAttribute", "addGroupAttribute",
        "addFileAttributeEx", "addSlideAttributeEx", "addGroupAttributeEx",
        "addCategorizedFileAttribute", "addCategorizedSlideAttribute", "addCategorizedGroupAttribute",
        "addCategorizedFileAttributeEx", "addCategorizedSlideAttributeEx", "addCategorizedGroupAttributeEx",
        "addMinModifiedDate", "addMaxModifiedDate",
        "addMinImportDate", "addMaxImportDate", "setFiltersConjunction",
        "getOutputType", "getResultAttribute"
    ],

    options: {
        method: "post",
        loadComplete: null, /*(json, text)*/
        catType: Librarian.catType.file,
        cancelAll: false,
        useCustomPath: true
    },

    isRecommendationSearch: false,

    emptyResult: {
        data: [],
        page: 1,
        total: 0
    },

    xmlDoc: null,

    initialize: function(options) {
        if ((typeof options == "undefined") || (options == null))
            options = {};

        this.setOptions(options);

        this.options.onSuccess = this.loadComplete;
        this.options.onException = options.onException;
        this.options.onFailure = options.onFailure || this.onFailure;

        if ((typeof this.options.url != "string") || (this.options.url.length == 0))
            this.options.url = Librarian.path.getSearchUrl() + "out=dgrid";

        this.parent(this.options);

        this.xmlDoc = this.loadSearchXML();
    },

    destroy: function() {
        this.cancel();
        this.clean();
        this.xmlDoc = null;
    },

    clean: function() {
        this.response = null;

        this.xhr = null;

        this.xhr = new Browser.Request();
    },

    loadSearchXML: function() {
        var path = Librarian.search.xmlPath;
        if (!path || !this.options.useCustomPath)
            path = Librarian.path.getLayoutsPath() + "core/search/search.xml";
        return Librarian.Utils.loadCustomXML(path + '?' + Librarian.buildVersion);
    },

    loadCustomXML: function(path) {
        this.xmlDoc = Librarian.Utils.loadCustomXML(path + '?' + Librarian.buildVersion);
    },

    onBeforeSearch: function() {
        // Should be overwritten on a per-library basis
        return true;
    },

    onBeforeXMLGeneration: function() {
        // Should be overwritten on a per-instance basis
    },

    search: function() {
        if (!this.onBeforeSearch())
            return;

        var filters = this.xmlDoc.getElementsByTagName("filter");
        // Removed unused filters
        for (var i = 0; i < filters.length; i++) {
            if (filters[i].getAttribute("used") != "true")
                filters[i].parentNode.removeChild(filters[i]);
        }

        this.onBeforeXMLGeneration();

        var xml = Librarian.Utils.getXMLText(this.xmlDoc);

        if (typeof Base64 != "undefined")
            xml = Base64.encode(xml);

        this.options.data = xml;
        this.send();
    },

    clone: function(search) {
        search.options.loadComplete = this.options.loadComplete;
        search.options.onSuccess = this.options.onSuccess;
        search.options.onFailure = this.options.onFailure;
        search.options.url = this.options.url;
        search.xmlDoc = Librarian.Utils.cloneXMLDoc(this.xmlDoc);
    },

    loadComplete: function(json, text) {
        if (typeof this.options.loadComplete == "function")
            this.options.loadComplete(json, text, this.options.catType, this.options.cancelAll);
    },

    // Return an empty set if there is an error
    onFailure: function() {
        if (typeof this.options.loadComplete == "function")
            this.options.loadComplete(this.emptyResult, JSON.stringify(this.emptyResult), this.options.catType, this.options.cancelAll);
    },

    hasSearchNodes: function() {
        var filterEls = this.xmlDoc.getElementsByTagName("filter");
        for (var i = 0; i < filterEls.length; i++) {
            if (filterEls[i].childNodes.length > 0)
                return true;
        }

        return false;
    },

    hasSearchNode: function(type, value, conjunction, operator, attributes, attributeValues, filterEl) {
        attributes = Array.from(attributes);
        attributeValues = Array.from(attributeValues);

        if (attributes.length != attributeValues.length)
            throw "Attribute list and attribute values list must have the same length";

        var attributeQueries = [];
        for (var i = attributes.length; i--;)
            attributeQueries.push('@' + attributes[i] + "='" + attributeValues[i] + "'");

        // TODO: Use conjunction, operator?
        var query = ".//" + type;

        // Add each attribute to the query string
        if (attributeQueries.length > 0)
            query += '[' + attributeQueries.join(" and ");

        // If we also have a string value, add that to the query
        if (typeof value == "string")
            query += " and text()='" + value + '\'';

        // If we added anything to the query string, close it
        if (query.contains('['))
            query += ']';

        if (filterEl)
            return filterEl.selectSingleNode(query) != null;
        return this.xmlDoc.selectSingleNode(query) != null;
    },

    addSearchWithin: function(value) {
        var filterEls = this.xmlDoc.getElementsByTagName("filter");
        for (var i = 0; i < filterEls.length; i++) {
            for (var j = 0; j < filterEls[i].childNodes.length; j++) {
                var parentEl = filterEls[i].childNodes[j];
                if (parentEl.childNodes.length > 0) {
                    parentEl.setAttribute("conjunction", "AND");
                    parentEl.appendChild(Librarian.Utils.cloneXMLNode(this.xmlDoc, parentEl.childNodes[0], value));
                }
            }
        }
    },

    addTextTerm: function(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addTextTermEx(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) != null;
    },

    addFileTerm: function(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addFileTermEx(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) != null;
    },

    addGroupTerm: function(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addGroupTermEx(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) != null;
    },

    addEventGroupTerm: function(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl) {
        return this.addEventGroupTermEx(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl) != null;
    },

    addRequestTerm: function(term, conjunction, operator, name, filterConjunction, createNewFilter, filterEl) {
        return this.addRequestTermEx(term, conjunction, operator, name, filterConjunction, createNewFilter, filterEl) != null;
    },

    addTextTermEx: function(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) {
        if ((typeof flags == "undefined") || (flags == null))
            flags = -1;

        return this.addTerm("text", term, conjunction, operator, null, null, "textTypes", flags, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addFileTermEx: function(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) {
        if ((typeof flags == "undefined") || (flags == null))
            flags = -1;

        return this.addTerm("file", term, conjunction, operator, "searchFields", flags, null, null, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addGroupTermEx: function(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addTerm("group", term, conjunction, operator, null, null, "searchFields", flags, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addEventGroupTermEx: function(term, conjunction, operator, flags, filterConjunction, createNewFilter, filterEl) {
        return this.addTerm("eventGroup", term, conjunction, operator, null, null, "searchFields", flags, filterConjunction, createNewFilter, filterEl);
    },

    addRequestTermEx: function(term, conjunction, operator, name, filterConjunction, createNewFilter, filterEl) {
        return this.addTerm("request", term, conjunction, operator, "name", name, null, null, filterConjunction, createNewFilter, filterEl);
    },

    addTerm: function(type, term, conjunction, operator, flagAttribute, flags, parentFlagAttribute, parentFlag, filterConjunction, createNewFilter, filterEl, outputType) {
        // Don't add full text noise words, but don't fail either
        if (Librarian.search.fullText && Librarian.search.noiseWords.contains(term.toLowerCase()))
            return (typeof filterEl == "undefined" || filterEl == null) ? true : filterEl;

        return this.addNode(type + "Term", term, flagAttribute, flags, conjunction, operator, parentFlagAttribute, parentFlag, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addFileKeyword: function(keyword, conjunction, operator, notUsed, filterConjunction, createNewFilter, outputType) {
        return this.addKeyword("file", keyword, conjunction, operator, filterConjunction, createNewFilter, null, outputType) != null;
    },
    
    addSlideKeyword: function(keyword, conjunction, operator, notUsed, filterConjunction, createNewFilter, outputType) {
        return this.addKeyword("slide", keyword, conjunction, operator, filterConjunction, createNewFilter, null, outputType) != null;
    },

    addGroupKeyword: function(keyword, conjunction, operator, notUsed, filterConjunction, createNewFilter, outputType) {
        return this.addKeyword("group", keyword, conjunction, operator, filterConjunction, createNewFilter, null, outputType) != null;
    },

    addEventGroupKeyword: function(keyword, conjunction, operator, notUsed, filterConjunction, createNewFilter) {
        return this.addKeyword("eventGroup", keyword, conjunction, operator, filterConjunction, createNewFilter) != null;
    },

    addFileKeywordEx: function(keyword, conjunction, operator, notUsed, filterConjunction, createNewFilter, filterEl) {
        return this.addKeyword("file", keyword, conjunction, operator, filterConjunction, createNewFilter, filterEl);
    },

    addSlideKeywordEx: function(keyword, conjunction, operator, notUsed, filterConjunction, createNewFilter, filterEl) {
        return this.addKeyword("slide", keyword, conjunction, operator, filterConjunction, createNewFilter, filterEl);
    },

    addGroupKeywordEx: function(keyword, conjunction, operator, notUsed, filterConjunction, createNewFilter, filterEl) {
        return this.addKeyword("group", keyword, conjunction, operator, filterConjunction, createNewFilter, filterEl);
    },

    addEventGroupKeywordEx: function(keyword, conjunction, operator, notUsed, filterConjunction, createNewFilter, filterEl) {
        return this.addKeyword("eventGroup", keyword, conjunction, operator, filterConjunction, createNewFilter, filterEl);
    },

    addKeyword: function(type, keyword, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addNode(type + "Keyword", keyword, null, null, conjunction, operator, null, null, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addFileType: function(attribute, attributeValue, exclude, conjunction, filterConjunction, createNewFilter, filterEl) {
        return this.addFileTypeEx(attribute, attributeValue, exclude, conjunction, filterConjunction, createNewFilter, filterEl) != null;
    },

    addFileTypeEx: function(attribute, attributeValue, exclude, conjunction, filterConjunction, createNewFilter, filterEl) {
        // If this is the ID, it should be a number
        if ((attribute == "id") && isNaN(attributeValue))
            return null;

        if (exclude == true)
            return this.addNode("fileType", null, [attribute, "exclude"], [attributeValue, "true"], conjunction, null, null, null, filterConjunction, createNewFilter, filterEl);
        else
            return this.addNode("fileType", null, attribute, attributeValue, conjunction, null, null, null, filterConjunction, createNewFilter, filterEl);
    },

    addCategory: function(catId, exclude, catType, catPath, filterConjunction, createNewFilter, filterEl, catName) {
        return this.addCategoryEx(catId, exclude, catType, catPath, filterConjunction, createNewFilter, filterEl, catName) != null;
    },

    addCategoryEx: function(catId, exclude, catType, catPath, filterConjunction, createNewFilter, filterEl, catName) {
        if (typeof catId == "number")
            catId = catId.toString();

        function addCatNode(filterListEl, createNew) {
            var attributes = ["catId", "catType"],
                attributeValues = [catId, catType];

            if (exclude === true) {
                attributes.push("exclude");
                attributeValues.push("true");
            }
            if ((typeof catPath == "string") && (catPath.trim().length > 0)) {
                attributes.push("catPath");
                attributeValues.push(catPath.trim());
            }
            if ((typeof catName == "string") && (catName.trim().length > 0)) {
                attributes.push("catName");
                attributeValues.push(catName.trim());
            }

            if (!this.hasSearchNode("category", null, null, null, attributes, attributeValues, filterListEl))
                return this.addNode("category", null, attributes, attributeValues, null, null, null, null, filterConjunction, createNew, filterListEl);
            return true;
        }

        if (createNewFilter === true)
            return addCatNode.apply(this, [null, true]);
        else if (filterEl != null)
            return addCatNode.apply(this, [filterEl]);
        else {
            this.deleteEmptyFilters();
            // If we're not creating a new filter, get the list of current filters to add the category to
            var filterEls = this.xmlDoc.getElementsByTagName("filter");

            for (var i = 0; i < filterEls.length; i++) {
                var filterListEl = filterEls[i];
                if (addCatNode.apply(this, [filterListEl]) == null)
                    return null;
            }
        }

        return true;
    },

    addFileAttribute: function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, outputType) {
        return this.addFileAttributeEx(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, null, outputType) != null;
    },

    addSlideAttribute: function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter) {
        return this.addSlideAttributeEx(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter) != null;
    },

    addGroupAttribute: function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, outputType) {
        return this.addGroupAttributeEx(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, null, outputType) != null;
    },

    addEventGroupAttribute: function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter) {
        return this.addEventGroupAttributeEx(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter) != null;
    },

    addFileAttributeEx: function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addAttribute("file", value, attributeValue, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addSlideAttributeEx: function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, filterEl) {
        return this.addAttribute("slide", value, attributeValue, conjunction, operator, filterConjunction, createNewFilter, filterEl);
    },

    addGroupAttributeEx: function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addAttribute("group", value, attributeValue, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addEventGroupAttributeEx: function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, filterEl) {
        return this.addAttribute("eventGroup", value, attributeValue, conjunction, operator, filterConjunction, createNewFilter, filterEl);
    },

    addAttribute: function(type, value, attributeValue, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addNode(type + "Attribute", value, "name", attributeValue, conjunction, operator, null, null, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addCategorizedFileAttribute: function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, outputType) {
        return this.addCategorizedFileAttributeEx(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, null, outputType) != null;
    },

    addCategorizedSlideAttribute: function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter) {
        return this.addCategorizedSlideAttributeEx(catId, value, name, conjunction, operator, filterConjunction, createNewFilter) != null;
    },

    addCategorizedGroupAttribute: function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, outputType) {
        return this.addCategorizedGroupAttributeEx(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, null, outputType) != null;
    },

    addCategorizedEventGroupAttribute: function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter) {
        return this.addCategorizedEventGroupAttributeEx(catId, value, name, conjunction, operator, filterConjunction, createNewFilter) != null;
    },

    addCategorizedFileAttributeEx: function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addCategorizedAttribute("file", catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addCategorizedSlideAttributeEx: function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl) {
        return this.addCategorizedAttribute("slide", catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl);
    },

    addCategorizedGroupAttributeEx: function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType) {
        return this.addCategorizedAttribute("group", catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addCategorizedEventGroupAttributeEx: function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl) {
        return this.addCategorizedAttribute("eventGroup", catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl);
    },

    addCategorizedAttribute: function(type, catId, value, name, conjunction, operator, filterConjunction, createNewFilter, filterEl, outputType) {
        var attributes = ["catId", "includeChildren", "value", "name"],
            values = [catId, Librarian.search.includeCategorizedMetaChildren, value, name];

        return this.addNode(type + "CategorizedAttribute", null, attributes, values, conjunction, operator, null, null, filterConjunction, createNewFilter, filterEl, outputType);
    },

    addContent: function(eventId, contactId, contactType, filterConjunction) {
        var filterEls = this.xmlDoc.getElementsByTagName("filter");
        // If there are no filters, add "null" to the list so a new one gets created automatically
        if (filterEls.length == 0)
            filterEls = [null];

        for (var i = 0; i < filterEls.length; i++) {
            var filterEl = filterEls[i];
            if (this.addNode("content", null, "eventId", eventId, null, null, ["contactId", "contactType"], [contactId, contactType], filterConjunction, false, filterEl) == null)
                return false;
        }

        return true;
    },

    addParentNode: function(type, conjunction, attribute, attributeValue, parentAttribute, parentAttributeValue, filterConjunction, createNewFilter, filterEl, outputType) {
        // Get the plural of the type
        var plural;

        // Use the library, if possible
        if (typeof owl != "undefined")
            plural = owl.pluralize(type);
            // If the library doesn't exist, do it manually
        else {
            plural = type + 's';
            if (type.charAt(type.length - 1) == 'y')
                plural = type.substring(0, type.length - 1) + "ies";
        }

        // If we're not given a filter, get the filter element for the given conjuction, or the first filter if there was none
        if (!filterEl)
            filterEl = this.getFilterElement(filterConjunction, type, attribute, attributeValue, outputType);

        // If we're supposed to be creating a new filter, clone the one we found
        if (createNewFilter) {
            filterEl = filterEl.cloneNode(true);

            // Set the conjunction just in case
            if (filterConjunction)
                filterEl.setAttribute("conjunction", filterConjunction);

            // Remove all non-category types
            for (var i = 0; i < filterEl.childNodes.length; i++) {
                var nodeEl = filterEl.childNodes[i];

                if (nodeEl.nodeName != "categories") {
                    i--;
                    nodeEl.parentNode.removeChild(nodeEl);
                }

                nodeEl = null;
            }

            // And add the clone to the filters list
            this.xmlDoc.getElementsByTagName("filters")[0].appendChild(filterEl);
        }

        var parentEl = this.xmlDoc.createElement(plural);

        // If no conjunction was passed, use the Library's default
        if (!conjunction)
            conjunction = Librarian.search.defaultConjunction;

        parentEl.setAttribute("conjunction", conjunction);
        this.setNodeAttributes(parentEl, parentAttribute, parentAttributeValue);

        filterEl.setAttribute("used", "true");
        filterEl.appendChild(parentEl);
        return { parent: parentEl, filter: filterEl };
    },

    addNode: function(type, value, attribute, attributeValue, conjunction, operator, parentAttribute, parentAttributeValue, filterConjunction, createNewFilter, filterEl, outputType) {
        if ((typeof createNewFilter == "undefined") || (createNewFilter == null))
            createNewFilter = false;

        var nodeEl = this.xmlDoc.createElement(type);
        if (value) {
            var match = value.match(/"/g);

            // Find an odd number of "s in a search query
            // EX: "global" "market
            if (match && (match.length % 2 != 0)) {
                Librarian.Utils.error(Librarian.Lang.getString("search_unmatchedquote"));
                return null;
            }

            nodeEl.appendChild(this.xmlDoc.createTextNode(value));

            // If there is a blank value given, we are probably searching for "All"
            // However, we do not want to override an operator if there already is one
            if ((nodeEl.getAttribute("operator") == null) && (value.length <= 0))
                nodeEl.setAttribute("operator", "NotEquals");
        }

        // Set the operator on this node
        if (operator && (operator.trim().length > 0))
            nodeEl.setAttribute("operator", operator.trim());

        this.setNodeAttributes(nodeEl, attribute, attributeValue);

        // If we're not given a filter, get the filter element for the given conjuction, or the first filter if there was none
        if (!filterEl)
            filterEl = this.getFilterElement(filterConjunction, type, attribute, attributeValue, outputType);

        // Set this filter as "used" so that it's not deleted before sending
        filterEl.setAttribute("used", "true");

        // Get the plural of the type
        var plural;

        // Use the library, if possible
        if (typeof owl != "undefined")
            plural = owl.pluralize(type);
        // If the library doesn't exist, do it manually
        else {
            plural = type + 's';
            if (type.charAt(type.length - 1) == 'y')
                plural = type.substring(0, type.length - 1) + "ies";
        }

        // Get the parent node
        var parentEl = filterEl.getElementsByTagName(plural)[0];

        // If this parent node doesn't exist already, create it
        if ((parentEl == null) || createNewFilter) {
            var result = this.addParentNode(type, conjunction, attribute, attributeValue, parentAttribute, parentAttributeValue, filterConjunction, createNewFilter, filterEl);
            parentEl = result.parent;
            filterEl = result.filter;
        }
        else {
            // If no conjunction was passed, use the Library's default
            if (!conjunction)
                conjunction = Librarian.search.defaultConjunction;

            parentEl.setAttribute("conjunction", conjunction);
        }

        // Then add the node to it
        parentEl.appendChild(nodeEl);

        nodeEl = null;
        parentEl = null;

        return filterEl;
    },

    setNodeAttributes: function(nodeEl, attribute, attributeValue) {
        // If we are given an attribute and a value for it, we need to add it
        if (attribute && (typeof attributeValue != "undefined") && (attributeValue != null)) {
            // If they are both arrays, make sure to add each pair individually
            if ((typeOf(attribute) == "array") && (typeOf(attributeValue) == "array")) {
                for (var i = 0; (i < attribute.length) && (i < attributeValue.length) ; i++) {
                    if ((typeof attribute[i] == "undefined") || (attribute[i] == null) ||
                        (typeof attributeValue[i] == "undefined") || (attributeValue[i] == null))
                        continue;

                    // Make sure the value is a string
                    attributeValue[i] = attributeValue[i] + '';

                    // Don't set empty attributes or values
                    if ((attribute[i].length > 0) && (attributeValue[i].length > 0))
                        nodeEl.setAttribute(attribute[i], attributeValue[i]);
                }
            }
            else if (attributeValue.toString().length > 0)
                nodeEl.setAttribute(attribute, attributeValue);
        }
    },

    getChildElementByType: function(type, operator) {
        // Get the plural of the type
        var plural;

        // Use the library, if possible
        if (typeof owl != "undefined")
            plural = owl.pluralize(type);
            // If the library doesn't exist, do it manually
        else {
            plural = type + 's';
            if (type.charAt(type.length - 1) == 'y')
                plural = type.substring(0, type.length - 1) + "ies";
        }

        // Get the filter element for the given conjuction, or the first filter if there was none
        var filterEl = this.getFilterElement();
        // Get the parent node
        var parentEl = filterEl.getElementsByTagName(plural)[0];

        filterEl = null;

        return this.getChildElement(parentEl, operator);
    },

    getChildElement: function(parentEl, operator, attribute, attributeValue) {
        if (!parentEl || !parentEl.childNodes || (parentEl.childNodes.length == 0))
            return null;

        for (var i = 0; i < parentEl.childNodes.length; i++) {
            if (parentEl.childNodes[i].getAttribute("operator") == operator) {
                // Only return this item if we're not looking for an attribute or the attributes match
                if (!attribute || !attributeValue || (parentEl.childNodes[i].getAttribute(attribute) == attributeValue))
                    return parentEl.childNodes[i];
            }
        }

        return null;
    },

    getFilterElement: function(filterConjunction, type, attribute, attributeValue, outputType) {
        var filterEls = this.xmlDoc.getElementsByTagName("filter");

        // If there are no filters, create one
        if (filterEls.length == 0) {
            var filterEl = this.xmlDoc.createElement("filter");
            if ((typeof filterConjunction == "string") && (filterConjunction.length > 0))
                filterEl.setAttribute("conjunction", filterConjunction);

            if (outputType != null)
                filterEl.setAttribute("outputType", outputType);

            this.xmlDoc.getElementsByTagName("filters")[0].appendChild(filterEl);

            return filterEl;
        }

        // If this is an attribute...
        if (type && attribute && attributeValue && type.endsWith("Attribute") && !type.endsWith("CategorizedAttribute")) {
            // Find the filter with the matching attribute value
            for (var i = 0; i < filterEls.length; i++) {
                if ((outputType == null || (filterEls[i].getAttribute("outputType") == outputType.toString()))) {
                    var nodeEl = filterEls[i].selectSingleNode(".//" + type + "[@" + attribute + "='" + attributeValue + "']");
                    if (nodeEl)
                        return filterEls[i];
                }
            }
        }

        if ((typeof filterConjunction == "undefined") || (filterConjunction == null))
            return filterEls[0];

        // Find the filter with the matching conjuction
        // Default to the first filter unless we find one that already has one of these types in it
        // Also, go through this backawards so the newest filters are preferred
        var filterIndex = 0;
        for (var i = filterEls.length; i--; ) {
            if (filterEls[i].getAttribute("conjunction") == filterConjunction &&
                (outputType == null || (filterEls[i].getAttribute("outputType") == outputType.toString())))
            {
                filterIndex = i;

                if (type && Librarian.Utils.doesXMLHaveNode(filterEls[i], type))
                    return filterEls[i];
            }
        }

        return filterEls[filterIndex];
    },

    setFiltersConjunction: function(conjunction) {
        var filtersEl = this.xmlDoc.getElementsByTagName("filters")[0];
        if (filtersEl)
            filtersEl.setAttribute("conjunction", conjunction);
    },

    deleteEmptyFilters: function() {
        var filterEls = this.xmlDoc.getElementsByTagName("filter");
        for (var i = filterEls.length; i--;) {
            var filterEl = filterEls[i];
            if (!filterEl.childNodes || (filterEl.childNodes.length == 0) || ((filterEl.childNodes.length == 1) && (filterEl.childNodes[0].nodeName == "#text")))
                filterEl.parentNode.removeChild(filterEl);
        }
    },

    deleteEmptyNodes: function() {
        // Recursively delete all empty nodes
        this.recursiveDeleteEmpty(this.xmlDoc);
    },

    recursiveDeleteEmpty: function(nodeEl) {
        if (!nodeEl)
            return;

        // Check every child, if it has any
        if (nodeEl.childNodes) {
            for (var i = nodeEl.childNodes.length; i--;)
                this.recursiveDeleteEmpty(nodeEl.childNodes[i]);
        }

        // If this node has no children and no attributes, it's useless and should be removed
        // Text nodes are the exception
        if ((!nodeEl.childNodes || (nodeEl.childNodes.length == 0)) && (!nodeEl.attributes || (nodeEl.attributes.length == 0)) && (nodeEl.nodeName != "#text"))
            nodeEl.parentNode.removeChild(nodeEl);

        nodeEl = null;
    },

    addMinModifiedDate: function(value, filterConjunction, filterEl) {
        return this.addModifiedDate("min", value, filterConjunction, filterEl);
    },

    addMaxModifiedDate: function(value, filterConjunction, filterEl) {
        return this.addModifiedDate("max", value, filterConjunction, filterEl);
    },

    addModifiedDate: function(attribute, value, filterConjunction, filterEl) {
        return this.addDate(attribute, "Modified", value, filterConjunction, filterEl);
    },

    addMinImportDate: function(value, filterConjunction, filterEl) {
        return this.addImportDate("min", value, filterConjunction, filterEl);
    },

    addMaxImportDate: function(value, filterConjunction, filterEl) {
        return this.addImportDate("max", value, filterConjunction, filterEl);
    },

    addImportDate: function(attribute, value, filterConjunction, filterEl) {
        return this.addDate(attribute, "Imported", value, filterConjunction, filterEl);
    },

    addDate: function(attribute, type, value, filterConjunction, filterEl) {
        var append = false,
            dateEl = this.xmlDoc.getElementsByTagName("date" + type)[0];

        var outputType = filterEl ? parseInt(filterEl.getAttribute("outputType")) : null;
        if (outputType != null) {
            if ([Librarian.Search.outputTypes.FILES, Librarian.Search.outputTypes.GROUPS].contains(outputType)) {
                dateEl = filterEl.getElementsByTagName("date" + type)[0];
            }
        }

        if (dateEl == null) {
            append = true;
            dateEl = this.xmlDoc.createElement("date" + type);
        }

        dateEl.setAttribute(attribute, value);

        if (append) {
            filterEl = filterEl || this.getFilterElement(filterConjunction, null, null, null, outputType);
            if (filterEl) {
                filterEl.setAttribute("used", "true");
                filterEl.appendChild(dateEl);
            }

            filterEl = null;
        }

        dateEl = null;

        return true;
    },

    addOptions: function(flags, type, filterConjunction, outputType) {
        var append = false,
            optionsEl = this.xmlDoc.getElementsByTagName("options")[0];

        if (optionsEl == null) {
            append = true;
            optionsEl = this.xmlDoc.createElement("options");
        }

        if (flags) {
            var flagsEl = this.xmlDoc.createElement("searchFlags");
            flagsEl.appendChild(this.xmlDoc.createTextNode(flags));

            optionsEl.appendChild(flagsEl);

            flagsEl = null;
        }

        if (type) {
            var typeEl = this.xmlDoc.createElement("searchType");
            typeEl.appendChild(this.xmlDoc.createTextNode(type));

            optionsEl.appendChild(typeEl);

            typeEl = null;
        }

        // Only add this to the XML if there isn't one there already
        if (append) {
            var filterEl = this.getFilterElement(filterConjunction, null, null, null, outputType);
            if (filterEl)
                filterEl.appendChild(optionsEl);

            filterEl = null;
        }

        optionsEl = null;

        return true;
    },

    addResults: function(start, max, type, orderBy, order, viewName, returnType, includeDrafts) {
        var append = false,
            resultsEl = this.xmlDoc.getElementsByTagName("results")[0];

        if (resultsEl == null) {
            append = true;
            resultsEl = this.xmlDoc.createElement("results");
        }

        if (start)
            resultsEl.setAttribute("startRow", start);

        if (max && !Librarian.listView.enabled)
            resultsEl.setAttribute("maxRows", max);

        if ((typeof type != "undefined") && (type != null)) {
            resultsEl.setAttribute("outputType", type);

            if (type == Librarian.Search.outputTypes.GROUPS)
                this.options.catType = Librarian.catType.globalFavorite;
            else if (type == Librarian.Search.outputTypes.EVENTS || type == Librarian.Search.outputTypes.EVENTGROUPS)
                this.options.catType = Librarian.catType.event;
            else
                this.options.catType = Librarian.catType.file;
        }

        if (orderBy) {
            var appendOrder = false,
                appendOrders = false,
                // Get the order list element
                ordersEl = resultsEl.getElementsByTagName("orderByColumns")[0];
            // If it doesn't exist, create a new one
            if (ordersEl == null) {
                appendOrders = true;
                ordersEl = this.xmlDoc.createElement("orderByColumns");
            }

            // Find the first order element
            var orderEl = ordersEl.getElementsByTagName("orderByColumn")[0];
            // If the element doesn't exist, create a new one
            if (orderEl == null) {
                appendOrder = true;
                orderEl = this.xmlDoc.createElement("orderByColumn");
            }
            else if (!Librarian.search.overrideDefaultSorting) {
                var newOrderEl = this.xmlDoc.createElement("orderByColumn");
                ordersEl.insertBefore(newOrderEl, orderEl);
                orderEl = null;

                orderEl = newOrderEl;
            }

            orderEl.setAttribute("name", orderBy);
            if (order) {
                order = order.toCapitalCase();
                orderEl.setAttribute("order", order);
            }

            if (appendOrder)
                ordersEl.appendChild(orderEl);
            if (appendOrders)
                resultsEl.appendChild(ordersEl);

            orderEl = null;
            ordersEl = null;
        }

        if (viewName)
            resultsEl.setAttribute("viewName", viewName);
        // If there is a view name but we're given "false" explicitly, remove it
        else if ((viewName === false) && resultsEl.getAttribute("viewName"))
            resultsEl.setAttribute("viewName", '');

        // Save this for client-side use
        if ((typeof returnType == "string") && (returnType.length > 0))
            resultsEl.setAttribute("returnType", returnType);

        if (includeDrafts != null)
            resultsEl.setAttribute("includeDrafts", includeDrafts);

        // Only add this to the XML if there isn't one there already
        if (append)
            this.xmlDoc.getElementsByTagName("search")[0].appendChild(resultsEl);

        resultsEl = null;

        return true;
    },

    setSearchSource: function(searchSource) {
        var searchEl = this.xmlDoc.getElementsByTagName("search")[0];
        if (searchEl)
            searchEl.setAttribute("source", searchSource);
    },

    getOutputType: function() {
        return this.getResultAttribute("outputType");
    },

    getReturnType: function() {
        return this.getResultAttribute("returnType");
    },

    getResultAttribute: function(attribName) {
        if (!this.xmlDoc)
            return '';

        var resultEl = this.xmlDoc.getElementsByTagName("results")[0];
        if (resultEl == null)
            return '';
        return resultEl.getAttribute(attribName);
    },

    getSearchTerms: function() {
        if (!this.xmlDoc)
            return '';

        var terms = '',
            termEls = this.xmlDoc.selectNodes("//fileTerm | //textTerm | //groupTerm | //eventGroupTerm | //requestTerm");
        for (var k = 0; k < termEls.length; k++) {
            var text = Librarian.Utils.getXMLNodeText(termEls[k]);

            if ((typeof text == "undefined") || (text == null) || (text.length == 0))
                continue;

            text = text.replaceAll(Librarian.search.searchWildCard, '')
                        .replaceAll("\"", '');
            terms += text.split(" OR ").join(';')
                            .split(" AND ").join(';') + ';';
        }

        return terms.trim();
    },

    getTextTerms: function() {
        if (!this.xmlDoc)
            return '';

        var terms = '',
            textTerms = this.xmlDoc.getElementsByTagName("textTerm");
        for (var i = 0; i < textTerms.length; i++) {
            var text = Librarian.Utils.getXMLNodeText(textTerms[i]);

            if ((typeof text == "undefined") || (text == null) || (text.length == 0))
                continue;

            text = text.replaceAll(Librarian.search.searchWildCard, '')
                       .replaceAll("\"", '');
            terms += text.split(" OR ").join(';')
                         .split(" AND ").join(';') + ';';
        }

        return terms.trim();
    },

    getCurrentPage: function() {
        if (!this.xmlDoc)
            return null;

        var resultEl = this.xmlDoc.getElementsByTagName("results")[0];
        if (resultEl == null)
            return null;

        var startRow = resultEl.getAttribute("startRow");
        if (startRow == null)
            startRow = 1;
        else
            startRow = startRow.trim().toInt();

        var maxRows = resultEl.getAttribute("maxRows");
        if (maxRows == null)
            maxRows = Librarian.search.maxResults;
        else
            maxRows = maxRows.trim().toInt();

        return Math.ceil(startRow / maxRows);
    }
});

// Static variables and methods
Librarian.Search.extend({
    outputTypes: {
        ALLCONTENT: -1,
        FILES: 0,
        SLIDES: 1,
        GROUPS: 2,
        EVENTS: 3,
        EVENTGROUPS: 4,
        ARTICLES: 5,
        MYFAVORITE: 6,
        CATEGORIES: 7
    },
    searchSource: {
        undefined: 0,
        quick: 1,
        advanced: 2,
        application: 3,
        administrator: 4
    },
    fromSearch: false,

    openSearch: function() {
        if (!Librarian.searchWindow || !Librarian.searchWindow.isMinimized) {
            Librarian.searchWindow = new Librarian.Search.Window();
            Librarian.searchWindow.show();
        }
        else if (Librarian.searchWindow.isMinimized)
            Librarian.searchWindow.restore();
    },

    searchAgain: function() {
        if (!Librarian.searchWindow || !Librarian.searchWindow.isMinimized)
            Librarian.Search.openSearch();
        else if (Librarian.searchWindow.isMinimized)
            Librarian.searchWindow.restore();
    },

    prepValue: function(value, appendWildCard, conjunction) {
        // CLN-2783 - Strip all v-tabs because they can't be put in XML
        value = value.replaceAll("\u000b", '');

        // If this is a full-text search and the value already has a conjunction in it, don't process it at all
        if (Librarian.search.fullText && (value.toUpperCase().contains(" AND ") || value.toUpperCase().contains(" OR ")))
            return value;

        // Strip %, <, >, [, ], *
        value = value.replace(/(\%|<|>|\[|\]|\*)/g, '');

        // If we weren't given a conjunction, use the default
        if ((typeof conjunction == "undefined") || (conjunction == null))
            conjunction = Librarian.search.defaultConjunction;

        // '.'s are not valid in search values, so remove them all
        value = value.replaceAll('.', ' ');
        // Get an array of values, split on the quotes
        // Use safeSplit so the quotes aren't destroyed
        var quotedValues = value.safeSplit('"'),
            values = [],
            hadQuotes = false,
            appendValue = '';

        if ((appendWildCard !== false) && Librarian.search.appendWildcardOnSplit)
            appendValue = Librarian.search.searchWildCard;

        if (!Librarian.search.fullText)
            conjunction = '';

        // Go through each word
        for (var i = 0; i < quotedValues.length; i++) {
            var quotedValue = quotedValues[i].trim();
            // If its trimmed length is 0, skip it
            if (quotedValue.length == 0)
                continue;

            // If this word isn't encapsulated in quotes
            if (!quotedValue.startsWith('"') && !quotedValue.endsWith('"')) {
                // Split on ' ' '-' '–' '—' '_'
                var splitValues = quotedValue.match(/[^\s\-–—_]+/g);

                // If there are spaces
                if (splitValues.length > 1) {
                    // Loop through each word in the spaces list
                    // and add them to the list of values
                    for (var j = 0; j < splitValues.length; j++) {
                        var splitValue = splitValues[j].replaceAll('"', '').trim();

                        // Don't keep noise words if we are doing a full-text search
                        if (Librarian.search.fullText && Librarian.search.noiseWords.contains(splitValue.toLowerCase())) {
                            splitValues.remove(j);
                            j--;
                        }
                        else
                            values.push(splitValue + appendValue);
                    }

                    // Add the concatenated word to the list as well, but only if we're doing OR
                    // This concatenated value would kill AND searches
                    // Make sure there is still more than one value left after we cleaned out the noise words
                    if ((conjunction == "OR") && (splitValues.length > 1))
                        values.push(splitValues.join(''));
                    continue;
                }
                // Otherwise, make sure this word isn't a noise word if we're doing a full-text search
                else if (Librarian.search.fullText && Librarian.search.noiseWords.contains(quotedValue.toLowerCase()))
                    continue;
            }
            else
                hadQuotes = true;

            // Otherwise just add the word to the values list directly,
            // making sure to replace all quotes with nothing so we don't double up
            values.push(quotedValue.replaceAll('"', '').trim() + appendValue);
        }

        if (!Librarian.search.fullText)
            hadQuotes = false;

        // If there is only one value, return it
        if (values.length == 1) {
            if (hadQuotes)
                value = '"' + values[0] + '"';
            else
                value = values[0];
        }
        // If there are multiple values, encapsulate the whole thing in quotes
        // and join each word with " [Conjunction] "
        else if (values.length > 1) {
            if (Librarian.search.fullText)
                value = '"' + values.join('" ' + conjunction + ' "') + '"';
            else {
                if (appendValue.length == 0)
                    value = values.join(' ');
                else
                    value = values.join('');
            }
        }

        // Return the value
        // NOTE: If there are no values in the values array,
        // this is just the same word that was passed in
        return value;
    },

    extractAndPrepCategory: function(search, value) {
        // Shortcut way to make sure numbers are treated as strings
        value = '' + value;
        var catid = value;

        // If the value has a 'S' prepended to it,
        // that means it should be displaying slide output
        var index = value.indexOf('S');
        if (index >= 0) {
            search.addResults(null, null, Librarian.Search.outputTypes.SLIDES);
            catid = value.substring(0, index) + value.substring(index + 1, value.length);
        }

        // If the value has a 'G' prepended to it,
        // that means it should be displaying group output
        index = value.indexOf('G');
        if (index >= 0) {
            search.addResults(null, null, Librarian.Search.outputTypes.GROUPS);
            catid = value.substring(0, index) + value.substring(index + 1, value.length);
        }

        return catid;
    },

    prepSearchNavigation: function(maxItems, numItems, lockNavigation) {
        // If this is from search, reset the boolean but don't do anything else
        if (Librarian.Search.fromSearch) {
            Librarian.Search.fromSearch = false;
            return;
        }

        if ((typeof lockNavigation == "undefined") || (lockNavigation == null))
            lockNavigation = false;

        if (lockNavigation)
            return;

        var pages = Math.ceil(numItems / maxItems);
        // If we have more than 1 page
        if (pages > 1) {
            Librarian.Search.showSearchNavigation(true);

            // Fill in the page count also
            var itemEl = $("navPageCountTop");
            if (itemEl)
                itemEl.set("text", pages);

            itemEl = $("navPageCountBottom");
            if (itemEl)
                itemEl.set("text", pages);

            Librarian.Search.updateSearchButtons(pages);
        }
        // Hide the navigation buttons by default
        else
            Librarian.Search.showSearchNavigation(false);
    },

    showSearchNavigation: function(show, reset) {
        var display = show ? "block" : "none";

        // Display the navigation areas
        // But only if they aren't forced off
        var itemEl = $("navigationTop");
        if (itemEl) {
            if (itemEl.style.forceDisplay == null)
                itemEl.style.display = display;
            else
                itemEl.style.display = itemEl.style.forceDisplay;
        }

        itemEl = $("navigationBottom");
        if (itemEl) {
            if (itemEl.style.forceDisplay == null)
                itemEl.style.display = display;
            else
                itemEl.style.display = itemEl.style.forceDisplay;
        }

        // Reset the current counts if we're told to
        if (reset) {
            Librarian.Utils.setElementValue($("navCurPageTop"), 1);
            Librarian.Utils.setElementValue($("navCurPageBottom"), 1);
        }
    },

    updateSearchButtons: function(pages) {
        var itemEl = $("navCurPageTop");
        if (itemEl) {
            var disablePrev = true,
                disableNext = false;

            if (itemEl.value == pages)
                disableNext = true;

            if (itemEl.value != 1)
                disablePrev = false;

            itemEl = $("navFirstPageButtonTop");
            var wrapperEl = $("navFirstPageTop");
            if (itemEl && wrapperEl)
                Librarian.Utils.setButtonState(itemEl, wrapperEl, disablePrev);

            itemEl = $("navFirstPageButtonBottom");
            wrapperEl = $("navFirstPageBottom");
            if (itemEl && wrapperEl)
                Librarian.Utils.setButtonState(itemEl, wrapperEl, disablePrev);

            itemEl = $("navPrevPageButtonTop");
            wrapperEl = $("navPrevPageTop");
            if (itemEl && wrapperEl)
                Librarian.Utils.setButtonState(itemEl, wrapperEl, disablePrev);

            itemEl = $("navPrevPageButtonBottom");
            wrapperEl = $("navPrevPageBottom");
            if (itemEl && wrapperEl)
                Librarian.Utils.setButtonState(itemEl, wrapperEl, disablePrev);

            itemEl = $("navNextPageButtonTop");
            wrapperEl = $("navNextPageTop");
            if (itemEl && wrapperEl)
                Librarian.Utils.setButtonState(itemEl, wrapperEl, disableNext);

            itemEl = $("navNextPageButtonBottom");
            wrapperEl = $("navNextPageBottom");
            if (itemEl && wrapperEl)
                Librarian.Utils.setButtonState(itemEl, wrapperEl, disableNext);

            itemEl = $("navLastPageButtonTop");
            wrapperEl = $("navLastPageTop");
            if (itemEl && wrapperEl)
                Librarian.Utils.setButtonState(itemEl, wrapperEl, disableNext);

            itemEl = $("navLastPageButtonBottom");
            wrapperEl = $("navLastPageBottom");
            if (itemEl && wrapperEl)
                Librarian.Utils.setButtonState(itemEl, wrapperEl, disableNext);
        }
    },

    navPage: function(page, pages, perPage, resetTileList) {
        if ((Librarian.lastSearch == undefined) || (Librarian.lastSearch == null))
            return;
        if ((typeof perPage == "undefined") || (perPage == null))
            perPage = Librarian.search.maxResults;
        if ((typeof resetTileList == "undefined") || (resetTileList == null))
            resetTileList = true;

        Librarian.Search.updateSearchButtons(pages);

        if (resetTileList && tileList && tileList.wrapper) {
            tileList.reset();
            tileList.wrapper.appendChild(document.createTextNode(Librarian.Lang.getString("searching")));
        }

        if (!Librarian.listView.enabled) {
            // Set Librarian.Search to true so we don't update the page counts and stuff like
            // that when we are just switching between search pages
            Librarian.Search.fromSearch = true;
        }

        // Clean the last search
        Librarian.lastSearch.cancel();
        Librarian.lastSearch.clean();

        // For page 2, (2 - 1) * 24 + 1 = 25, the correct starting location
        Librarian.lastSearch.addResults(((page - 1) * perPage) + 1, perPage);
        Librarian.lastSearch.search();

        var mainPanelEl = $("mainPanel");
        if (mainPanelEl)
            mainPanelEl.scrollTo(0, 0);
        else
            window.scrollTo(0, 0);
    },

    sortSearch: function(pages, sortOn, sortBy, resetTileList) {
        if ((Librarian.lastSearch == undefined) || (Librarian.lastSearch == null))
            return;
        if ((typeof resetTileList == "undefined") || (resetTileList == null))
            resetTileList = true;

        Librarian.Search.updateSearchButtons(pages);

        if (resetTileList && tileList && tileList.wrapper) {
            tileList.reset();
            tileList.wrapper.appendChild(document.createTextNode(Librarian.Lang.getString("searching")));
        }

        if (!Librarian.listView.enabled) {
            // Set Librarian.Search to true so we don't update the page counts and stuff like
            // that when we are just switching between search pages
            Librarian.Search.fromSearch = true;
        }

        // Clean the last search
        Librarian.lastSearch.cancel();
        Librarian.lastSearch.clean();

        // Reset to the first page
        Librarian.lastSearch.addResults(1, null, null, sortOn, sortBy);
        Librarian.lastSearch.search();

        var mainPanelEl = $("mainPanel");
        if (mainPanelEl)
            mainPanelEl.scrollTo(0, 0);
        else
            window.scrollTo(0, 0);
    },

    navPageSubmit: function(from) {
        var page = 0,
            pages = 1,
        // The opposite element from the one provided
            other = "Top";

        // If we are given Top, the opposite is bottom.
        // Librarian.Search is used to update the other text box to match.
        if (from == "Top")
            other = "Bottom";

        var curPageEl = $("navCurPage" + from);
        if (curPageEl) {
            if (isNaN(curPageEl.value))
                return;

            page = parseInt(curPageEl.value);
        }

        var pageCountEl = $("navPageCountTop");
        if (pageCountEl)
            pages = parseInt(pageCountEl.get("text"));

        if ((page > 0) && (page <= pages)) {
            curPageEl = $("navCurPage" + other);
            if (curPageEl)
                curPageEl.value = page;

            Librarian.Search.navPage(page, pages);
        }
    },

    navPageLocation: function(where) {
        var page = 0,
            pages = 1,
            curPageEl = $("navCurPageTop");
        if (curPageEl)
            page = parseInt(curPageEl.value);

        var pageCountEl = $("navPageCountTop");
        if (pageCountEl)
            pages = parseInt(pageCountEl.get("text"));

        if (where == "first")
            page = 1;
        else if (where == "prev")
            page--;
        else if (where == "next")
            page++;
        else if (where == "last")
            page = pages;

        // Only continue if the page value is valid
        if ((page > 0) && (page <= pages)) {
            if (curPageEl)
                curPageEl.value = page;

            curPageEl = $("navCurPageBottom");
            if (curPageEl)
                curPageEl.value = page;

            Librarian.Search.navPage(page, pages);
        }
    }
});
